/** Projects — edit form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  ENTITY_STATUS,
  updateProjectSchema,
  type Project,
  type UpdateProjectInput,
} from "@aos/shared";

import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader } from "./_shared";
import { LoadingState, ErrorState } from "./_shared";
import { FormGrid, SelectField, TextAreaField, TextField } from "./_form";

export function ProjectEdit() {
  const form = useForm<Project, any, UpdateProjectInput>({
    resolver: zodResolver(updateProjectSchema),
    refineCoreProps: { resource: "projects", action: "edit" },
  });

  const {
    refineCore: { formLoading, query },
    saveButtonProps,
    control,
  } = form;

  if (query?.isLoading) {
    return <LoadingState label="Loading project…" />;
  }
  if (query?.isError) {
    return <ErrorState error={query.error} />;
  }

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader title="Edit Project" description="Update project details." />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Project details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <FormGrid>
                <TextField control={control} name="name" label="Name" />
                <SelectField
                  control={control}
                  name="status"
                  label="Status"
                  options={ENTITY_STATUS}
                />
              </FormGrid>
              <TextField
                control={control}
                name="company_id"
                label="Company ID"
                description="Optional — link this project to a company."
              />
              <TextAreaField
                control={control}
                name="description"
                label="Description"
              />
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Saving…" : "Save Changes"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </div>
  );
}

export default ProjectEdit;
